<div>
    <h2>{{'totales.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'global.pais' | translate}}</label>
                <app-multiselect-list [itemsList]="paises" (shareCheckedList)="shareCheckedListPaises($event)"
                    [selectedItem]="filtersForm.get('pais')"
                    [disabled]="" [initialState]="initialStatePaises">
                </app-multiselect-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'totales.filters.denominacion' | translate}}</label>
                <app-multiselect-list [itemsList]="denominaciones" (shareCheckedList)="shareCheckedListDenominaciones($event)"
                    [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [initialState]="initialStateDenominaciones">
                </app-multiselect-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'totales.filters.campanya' | translate}}</label>
                <app-multiselect-list [itemsList]="campanyas" (shareCheckedList)="shareCheckedListCampanyas($event)"
                    [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [initialState]="initialStateCampanyas">
                </app-multiselect-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'totales.filters.etiquetador' | translate}}</label>
                <app-multiselect-list [itemsList]="etiquetadores" (shareCheckedList)="shareCheckedListEtiquetadores($event)"
                    [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [initialState]="initialStateEtiquetadores">
                </app-multiselect-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'totales.filters.marca' | translate}}</label>
                <app-multiselect-list [itemsList]="marcas" (shareCheckedList)="shareCheckedListMarcas($event)"
                    [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [initialState]="'noSelected'">
                </app-multiselect-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'totales.filters.destino' | translate}}</label>
                <app-multiselect-list [itemsList]="destinos" (shareCheckedList)="shareCheckedListDestinos($event)"
                    [selectedItem]="filtersForm.get('paisDestino')" [initialState]="'noSelected'">
                </app-multiselect-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="desglosePaisDestino" formControlName="desglosePaisDestino">
                <label for="desglosePaisDestino">{{'totales.filters.mostrarDesglose' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="fechasImpresion" formControlName="fechasImpresion">
                <label for="fechasImpresion">{{'totales.filters.mostrarFechas' | translate}}</label>
            </div>
            <div [ngClass]="{'entry-3-small': this.isSmallScreen, 'entry-4': !this.isSmallScreen, 'alignment-start-filters': addLastCheckboxClass }">
                <input type="checkbox" id="agruparEtiquetador" formControlName="agruparEtiquetador">
                <label for="agruparEtiquetador">{{'totales.filters.agruparEtiquetador' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fas fa-file-pdf" [ngClass]="{'disabled': !totales || (totales && totales.lsTotales.length < 1)}"
          (click)="exportPdfOrCsv('pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
      <i class="fas fa-file-csv" [ngClass]="{'disabled': !totales || (totales && totales.lsTotales.length < 1)}"
          (click)="exportPdfOrCsv('csv')" title="{{'titles.exportarCSV' | translate}}"></i>
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <content class="tabs" *ngIf="totales">
        <form>
            <h3>{{'totales.tabs.totalEtiquetas.titulo' | translate}}</h3>
            <section class="info-framed">
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'global.confeccionado' | translate}}</label>
                    <span>{{totales.totalNumEtiquetas ? (totales.totalNumEtiquetas | number : '' : defaultLanguage) : 0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'totales.tabs.totalEtiquetas.reetiquetado' | translate}}</label>
                    <span>{{totales.totalNumEtiquetasReimpresas ? (totales.totalNumEtiquetasReimpresas | number : '' :
                        defaultLanguage) : 0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'totales.tabs.totalEtiquetas.totalEtiquetas' | translate}}</label>
                    <span>{{totales.totalNumEtiquetas ? (totales.totalNumEtiquetas + totales.totalNumEtiquetasReimpresas
                        | number : '' : defaultLanguage) : 0}}</span>
                </div>
            </section>
            <h3>{{'totales.tabs.totalKilos.titulo' | translate}}</h3>
            <section class="info-framed">
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'totales.tabs.totalKilos.designados' | translate}}</label>
                    <span>{{totales.totalKgDesignados ? (totales.totalKgDesignados | number : '1.2-2': defaultLanguage) :
                        0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'global.confeccionadoKg' | translate}}</label>
                    <span>{{totales.totalKgImpresos ? (totales.totalKgImpresos | number : '1.2-2': defaultLanguage) : 0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'totales.tabs.totalKilos.reetiquetado' | translate}}</label>
                    <span>{{totales.totalKgReimpresos ? (totales.totalKgReimpresos | number : '1.2-2': defaultLanguage) :
                        0}}</span>
                </div>
            </section>
        </form>
        <div class="table-wrapper">
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th class="string sortable" (click)="toOrderBy('x=> x.desPais', 1)">
                                {{'global.pais' | translate}}
                                <i [ngClass]="getIcon('x=> x.desPais')"></i>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('x=> x.desDenominacion', 2)">
                                {{'totales.table.denominacion' | translate}}
                                <i [ngClass]="getIcon('x=> x.desDenominacion')"></i>
                            </th>
                            <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.desEtiquetador', 3)">
                                {{'totales.table.etiquetador' | translate}}
                                <i [ngClass]="getIcon('x=> x.desEtiquetador')"></i>
                            </th>
                            <th class="number sortable" (click)="toOrderBy('x=> x.anyo', 4)">
                                {{'totales.table.campanya' | translate}}
                                <i [ngClass]="getIcon('x=> x.anyo')"></i>
                            </th>
                            <th class="string sortable" *ngIf="destino" (click)="toOrderBy('x=> x.paisDestinoISO3', 5)">
                                {{'totales.table.destino' | translate}}
                                <i [ngClass]="getIcon('x=> x.paisDestinoISO3')"></i>
                            </th>
                            <th class="date sortable sortable-biggest" *ngIf="fechasImpresion" (click)="toOrderBy('x=> x.fechaImpresionPrimerConsumo', indexOrderFecha)">
                                <span [innerHTML]="('totales.table.primerConsumo' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.fechaImpresionPrimerConsumo')"></i>
                            </th>
                            <th class="date sortable sortable-biggest" *ngIf="fechasImpresion" (click)="toOrderBy('x=> x.fechaImpresionUltimoConsumo', indexOrderFecha+1)">
                                <span [innerHTML]="('totales.table.ultimoConsumo' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.fechaImpresionUltimoConsumo')"></i>
                            </th>
                            <th class="number sortable" *ngIf="!destino" (click)="toOrderBy('x=> x.sumaKgDesignados', indexOrder)">
                                {{'totales.table.designados' | translate}}
                                <i [ngClass]="getIcon('x=> x.sumaKgDesignados')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaKgImpresosEfectivos', indexOrder+1)">
                                <span [innerHTML]="('global.confeccionadoKg' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaKgImpresosEfectivos')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaKgReimpresos', indexOrder+2)">
                                <span [innerHTML]="('totales.table.reetiquetado' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaKgReimpresos')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaNumEtiquetasImpresasEfectivas', indexOrder+3)">
                                <span [innerHTML]="('totales.table.confeccionEtq' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaNumEtiquetasImpresasEfectivas')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaNumEtiquetasReimpresas', indexOrder+4)">
                                <span [innerHTML]="('totales.table.reetiquetadoEtq' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaNumEtiquetasReimpresas')"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let total of totales.lsTotales; let i = index;">
                        <tr *ngIf="i < lastItemList && i >= firstItemList">
                            <td class="string">{{total.desPais}}</td>
                            <td class="string">{{total.desDenominacion}}</td>
                            <td class="string-longest">{{total.desEtiquetador}}</td>
                            <td class="number">{{total.desAnyo}}</td>
                            <td class="string" *ngIf="destino">{{total.paisDestinoISO3}}</td>
                            <td class="date-longest" *ngIf="fechasImpresion">{{total.fechaImpresionPrimerConsumo | date:"dd/MM/yyyy hh:mm:ss"}}</td>
                            <td class="date-longest" *ngIf="fechasImpresion">{{total.fechaImpresionUltimoConsumo | date:"dd/MM/yyyy hh:mm:ss"}}</td>
                            <td class="number" *ngIf="!destino">{{total.sumaKgDesignados ? (total.sumaKgDesignados | number : '1.2-2': defaultLanguage) :
                                0}}</td>
                            <td class="number-longest" [ngClass]="{'red': (total.sumaKgImpresosEfectivos - total.sumaKgDesignados) > 0}">{{total.sumaKgImpresosEfectivos ? (total.sumaKgImpresosEfectivos | number :
                                '1.2-2': defaultLanguage) : 0}}</td>
                            <td class="number-longest">{{total.sumaKgReimpresos ? (total.sumaKgReimpresos | number : '1.2-2': defaultLanguage) :
                                0}}</td>
                            <td class="number-longest">{{total.sumaNumEtiquetasImpresasEfectivas ?
                                (total.sumaNumEtiquetasImpresasEfectivas | number : '' : defaultLanguage) : 0}}</td>
                            <td class="number-longest">{{total.sumaNumEtiquetasReimpresas ? (total.sumaNumEtiquetasReimpresas | number :
                                '' : defaultLanguage) : 0}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-paginator
            *ngIf="(totales && totales.lsTotales.length > 0) || (totales && totales.lsTotales.length > 0)"
            [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
            [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
            (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    </content>
    <section *ngIf="!totales || totales.length === 0">
        <div class="no-data">{{'global.noContent' | translate}}</div>
    </section>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>
